import { sortBy } from 'lodash';
import { useListProviders } from '../../utils/api.hook';
import { ProviderSelectorComponent } from './provider-selector.component';
import { ReactNode } from 'react';
import { NamePath } from 'antd/es/form/interface';

type Props = {
  multiple?: boolean;
  isRequired?: boolean;
  isDisabled?: boolean;
  label?: ReactNode;
  name?: NamePath<any>;
};

export function ProviderSelectorContainer(data: Props) {
  const { isLoading, data: { providers } = {} } = useListProviders();

  return (
    <ProviderSelectorComponent
      isDisabled={data.isDisabled}
      isLoading={isLoading}
      isRequired={data.isRequired}
      name={data.name}
      label={data.label}
      multiple={data.multiple}
      providers={sortBy(providers, (provider) =>
        parseInt(provider.idNumber, 10)
      )}
    />
  );
}
